import { render, staticRenderFns } from "./CarInfoBox.vue?vue&type=template&id=3e5a25d3&scoped=true&"
import script from "./CarInfoBox.vue?vue&type=script&lang=js&"
export * from "./CarInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./CarInfoBox.vue?vue&type=style&index=0&id=3e5a25d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a25d3",
  null
  
)

export default component.exports